<script lang="ts">import { onMount } from 'svelte';
let showIcon = $state(false);
let showText = $state(false);
let displayedText = $state('');
const fullText = 'Ask Square';
const iconDelay = 300;
const textStartDelay = 800;
const typingDelay = 50;
onMount(() => {
    setTimeout(() => {
        showIcon = true;
    }, iconDelay);
    setTimeout(() => {
        showText = true;
        typeText();
    }, textStartDelay);
});
function typeText() {
    let currentIndex = 0;
    const typeInterval = setInterval(() => {
        if (currentIndex < fullText.length) {
            displayedText = fullText.slice(0, Math.max(0, currentIndex + 1));
            currentIndex++;
        }
        else {
            clearInterval(typeInterval);
        }
    }, typingDelay);
}
</script>

<div class="startup-animation">
  <div class="startup-content">
    {#if showIcon}
      <div class="startup-icon" class:visible={showIcon}>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
          <path
            d="M8.72727 0C8.72727 2.71772 9.3895 4.48999 10.5369 5.59446C11.6899 6.70412 13.47 7.27273 16 7.27273V8.72727C13.47 8.72727 11.6899 9.29588 10.5369 10.4055C9.3895 11.51 8.72727 13.2823 8.72727 16H7.27273C7.27273 13.47 6.70412 11.6899 5.59446 10.5369C4.48999 9.3895 2.71772 8.72727 0 8.72727V7.27273C2.71772 7.27273 4.48999 6.6105 5.59446 5.46307C6.70412 4.31011 7.27273 2.53005 7.27273 0H8.72727Z"
            fill="black"
            fill-opacity="0.9"
          />
        </svg>
      </div>
    {/if}

    {#if showText}
      <div class="startup-text" class:visible={showText}>
        {displayedText}
      </div>
    {/if}
  </div>
</div>

<style>.startup-animation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 40px 20px;
  background: #ffffff;
}

.startup-content {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  gap: 8px;
}

.startup-icon {
  opacity: 0;
  transform: scale(0.8) translateY(10px);
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
}
.startup-icon.visible {
  opacity: 1;
  transform: scale(1) translateY(0);
}
.startup-icon svg {
  width: 20px;
  height: 20px;
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.1));
}

.startup-text {
  opacity: 0;
  transform: translateY(10px);
  transition: all 0.4s ease-out;
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}
.startup-text.visible {
  opacity: 1;
  transform: translateY(0);
}

@keyframes fadeInOut {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}
@keyframes blink {
  0%, 50% {
    opacity: 1;
  }
  51%, 100% {
    opacity: 0;
  }
}</style>
